module.exports = __webpack_public_path__ + "static/img/wechat_subscriptions.fc9a0f44.svg";